/** Domain service module: file.js */
import { request } from '../http/request'
import { getSelectedGroupId } from '../http/session'
import { API_BASE_URL } from './config'

class FileService {
  upload(file, data) {
    return new Promise(async (resolve, reject) => {
      try {
        let formData = new FormData()
        formData.append('fileBlob', file)
        formData.append('fileType', data.fileType)
        formData.append('selected_group_id', getSelectedGroupId())

        if (data.user_id) { formData.append('user_id', data.user_id) }
        if (data.legal_person_id) { formData.append('legal_person_id', data.legal_person_id) }
        if (data.event_id) { formData.append('event_id', data.event_id) }
        let _customHeaders = {
          'Content-Type': 'multipart/form-data',
        }
        // get me
        let _result = await request(`${API_BASE_URL}/file/upload`, 'POST', formData, null, _customHeaders)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
  delete(file) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/file/delete/${file.id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
}

export const file = new FileService()
export default file
